import * as React from 'react'
import { TFunction } from 'react-i18next'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

import Columns from 'components/Reporting/Overview/GraphicalDetails/TopPerformingTools/Columns'

const GetTable = (data: any, t: TFunction) => {
  const columns = Columns(t)

  return (
    <Table id="jspdf-table" sx={{ display: 'none' }}>
      <TableHead>
        <TableRow>
          {columns
            .filter((c) => c.field !== 'id')
            .map((column: any) => (
              <TableCell key={column?.field}>{column?.headerName}</TableCell>
            ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {data?.map((row: any) => (
          <TableRow key={row.id}>
            <TableCell>{row?.tool}</TableCell>
            <TableCell>{row?.project}</TableCell>
            <TableCell>{row?.contributions}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  )
}

export default GetTable
